export type PermissionLoadState = 'loading' | 'error' | 'ready';

export function resolvePermissionLoadState(
  isLoading: boolean,
  error: string | null,
): PermissionLoadState {
  if (isLoading) {
    return 'loading';
  }

  if (error) {
    return 'error';
  }

  return 'ready';
}
